import React from 'react';
import { Calendar } from 'react-date-range';
import moment from 'moment';

const maxDate = new Date();
const minDate = moment()
  .subtract(20, 'years')
  .utcOffset(120)
  .toDate();

const InfiniteCalendar = (props) => (
  <Calendar
    maxDate={maxDate}
    minDate={minDate}
    showMonthAndYearPickers={false}
    showMonthArrow={false}
    color="#000"
    scroll={{ enabled: true }}
    {...props}
  />
);

export default InfiniteCalendar;
